import { AccountTransactions } from "../account/AccountTransactions"
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Typography, Box } from '@mui/material';
import React from 'react';

export interface BackButtonProps {
    onBack: () => void;
    backButtonLabel: string;
}

export const BackButton: React.FC<BackButtonProps> = ({onBack, backButtonLabel}) => (
  <Box display="flex" alignItems="center" style={{cursor: 'pointer'}} onClick={onBack}>
    <IconButton color="inherit">
      <ArrowBackIcon />
    </IconButton>
    <Typography variant="body1">{backButtonLabel}</Typography>
  </Box>
)